"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPortalOrderStatusLabels = exports.WaysteOrderStatusLabels = exports.SourgumOrderStatusLabels = exports.OrderStatus = exports.OrderStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderStatuses = [
    'NEEDS_REVIEW',
    'UNASSIGNED',
    'ON_HOLD',
    'ASSIGNED',
    'DELIVERED',
    'READY_FULL_PICKUP',
    'READY_EMPTY_PICKUP',
    'PICKED_UP_FULL',
    'PICKED_UP_EMPTY',
    'DUMPED',
    'COMPLETED',
    'CANCELLED',
];
exports.OrderStatus = typebox_1.Type.Union(exports.OrderStatuses.map((value) => typebox_1.Type.Literal(value)));
exports.SourgumOrderStatusLabels = {
    NEEDS_REVIEW: 'Needs Review',
    UNASSIGNED: 'Unassigned',
    ON_HOLD: 'On Hold',
    ASSIGNED: 'Assigned',
    DELIVERED: 'Delivered',
    READY_FULL_PICKUP: 'Ready Pickup',
    READY_EMPTY_PICKUP: 'Ready Empty Pickup',
    PICKED_UP_FULL: 'Picked Up',
    PICKED_UP_EMPTY: 'Picked Up',
    DUMPED: 'Dumped',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};
exports.WaysteOrderStatusLabels = {
    NEEDS_REVIEW: 'Needs Review',
    UNASSIGNED: 'Unassigned',
    ON_HOLD: 'On Hold',
    ASSIGNED: 'Assigned',
    DELIVERED: 'Delivered',
    READY_FULL_PICKUP: 'Ready Pickup',
    READY_EMPTY_PICKUP: 'Ready Empty Pickup',
    PICKED_UP_FULL: 'Picked Up',
    PICKED_UP_EMPTY: 'Picked Up',
    DUMPED: 'Dumped',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};
exports.CustomerPortalOrderStatusLabels = {
    NEEDS_REVIEW: 'Under Review',
    UNASSIGNED: 'Awaiting Delivery',
    ASSIGNED: 'Awaiting Delivery',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    DELIVERED: 'Delivered',
    DUMPED: 'Dumped',
    ON_HOLD: 'On Hold',
    PICKED_UP_EMPTY: 'Picked up',
    PICKED_UP_FULL: 'Picked up',
    READY_FULL_PICKUP: 'Awaiting Pickup',
    READY_EMPTY_PICKUP: 'Awaiting Pickup',
};
//# sourceMappingURL=order-status.js.map